/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import App from '../components/app/app'
// import { AppRoutes } from '../system-design/app/routing/AppRoutes'
import { PrivateRoutes } from './PrivateRoutes'
import { AuthPage, Logout } from '../components/auth'
import { AUTH_TOKEN } from '../constants'
import ErrorPage from '../pages/ErrorPage/ErrorPage'
import { PlanProvider } from '../context/PlanContext'
import { UserProvider } from '../context/UserContext'
import { RolePermissionProvider } from '../context/RolePermissionContext'

const { PUBLIC_URL } = process.env

const MainAppRoutes: React.FC = () => {
  const isAuthorized = localStorage.getItem(AUTH_TOKEN) // User authentication logic should be inserted here
  console.log(isAuthorized)
  if (isAuthorized) {
    document.title = 'Botgo: Admin Panel'
  } else {
    document.title = 'Botgo: Login'
  }

  return (
    <>
      {isAuthorized ? (
        <UserProvider>
          <PlanProvider>
            <RolePermissionProvider>
              <BrowserRouter basename={PUBLIC_URL}>
                <Routes>
                  {/* <Route path='/system-design/*' element={<AppRoutes />} /> */}
                  <Route element={<App />}>
                    <Route path='/*' element={<PrivateRoutes />} />
                    {/* <Route index element={<Navigate to='/roles' />} /> */}
                    <Route path='logout' element={<Logout />} />
                    <Route path='error/*' element={<ErrorPage />} />
                  </Route>
                </Routes>
              </BrowserRouter>
            </RolePermissionProvider>
          </PlanProvider>
        </UserProvider>
      ) : (
        <BrowserRouter basename={PUBLIC_URL}>
          <Routes>
            <Route path='auth/*' element={<AuthPage />} />
            <Route path='*' element={<Navigate to='/auth' />} />
            <Route path='error/*' element={<ErrorPage />} />
          </Routes>
        </BrowserRouter>
      )}
    </>
  )
}

export { MainAppRoutes }
